import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        {
          text: 'نام و نام خانوادگی ',
          value: 'fullName',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'کد ملی',
          value: 'nationalCode',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شماره پرسنلی',
          value: 'personelNumber',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          isGroupable: true,
        },
        { text: 'نقش', value: 'role', align: 'center', isGroupable: true },
        { text: 'وضعیت', value: 'status', align: 'center', isGroupable: true },
        { text: 'عملیات', value: 'actions', align: 'center', sortable: false },
      ],
      tableItems: [],
      searchNationalCode: null,
      searchRoleId: null,
      searchFullName: null,
      userId: null,
      fullName: '',
      dashboardModal: false,
      userSelectedRole: null,
      userAllRoles: [],
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let fullName = '';
        fullName += data[i].firstName ? data[i].firstName : '-';
        fullName += ' ';
        fullName += data[i].lastName ? data[i].lastName : '-';
        this.tableItems.push({
          fullName: fullName,
          nationalCode: data[i].nationalCode ? data[i].nationalCode : '-',
          personelNumber: data[i].personnelNumber ? data[i].personnelNumber : '-',
          phoneNumber: data[i].phoneNumber ? data[i].phoneNumber : '-',
          role: data[i].roles ? data[i].roles : '-',
          status: data[i].isOnline,
          id: data[i].id,
        });
      }
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCUsersForQCReportFunction(
        this.searchFullName,
        this.searchRoleId,
        this.searchNationalCode,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchNationalCode = null;
      this.searchRoleId = null;
      this.searchFullName = '';
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCUsersForQCReportFunction(
        this.searchFullName,
        this.searchRoleId,
        this.searchNationalCode,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchNationalCode = null;
      this.searchRoleId = null;
      this.searchFullName = '';
      this.searchModal = false;
    },
    showDashboardSearchModal: function (data) {
      this.userId = data.id;
      this.getUserRoleList();
      this.fullName = data.fullName;
      this.dashboardModal = true;
    },
    cancelSearchDashboardMobile: function () {
      this.userId = null;
      this.userSelectedRole = null;
      this.fullName = '';
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.dashboardModal = false;
    },
    goToDashboard: function () {
      if (!this.userSelectedRole) {
        this.snackText = 'لطفا نقش کاربر را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.searchFromDate) {
        this.snackText = 'لطفا از تاریخ را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.searchToDate) {
        this.snackText = 'لطفا تا تاریخ را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      let roleId = this.userSelectedRole.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.fullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      if (roleId == 3) {
        //115
        this.$router.push({ name: 'qcUser115Dashboard', params: { id: id } });
      } else if (roleId == 2) {
        //800
        this.$router.push({ name: 'qcUser800Dashboard', params: { id: id } });
      } else if (roleId == 5) {
        //Technician
        this.$router.push({
          name: 'qcUserTechnicianDashboard',
          params: { id: id },
        });
      } else if (roleId == 8) {
        //doctor
        this.$router.push({
          name: 'qcUserDoctorDashboard',
          params: { id: id },
        });
      } else if (roleId == 6) {
        //doctor
        this.$router.push({
          name: 'qcUserAdmissionDashboard',
          params: { id: id },
        });
      }
    },
  },
  computed: {
    excelTableData: function () {
      return [...this.tableItems]?.map(({ status, ...rest }) => {
        const statusTxt = status ? 'آنلاین' : 'آفلاین';
        return {
          ...rest,
          status: statusTxt,
        };
      });
    },
  },
};
